import { axiosInstance, misbarInstance } from "api/services/axiosInstance";
import { PARCEl_NUMBER_URL, PROJECT_URL } from "constants/ApiConstants";

const parcelApi = {
  getParcelsData: (projectId, organisationId, type, cancelToken) =>
    axiosInstance.get(
      `org/${organisationId}/booking/project/${projectId}/map/parcels`,
      { params: { type }, cancelToken }
    ),
  getPublicParcelsData: (projectId, organisationId) =>
    axiosInstance.get(
      `org/${organisationId}/booking/project/${projectId}/map/public/parcels`
    ),
  getParcelById: (projectId, projectParcelId, cancelToken) =>
    axiosInstance.get(
      `${PARCEl_NUMBER_URL}/${projectId}/parcel/${projectParcelId}`,
      {
        cancelToken,
      }
    ),
  getParcelByNumber: (projectId, parcelNo) =>
    axiosInstance.get(`${PARCEl_NUMBER_URL}/${projectId}/parcels`, {
      params: { parcelNo },
    }),
  getParcelBuildingCodes: (projectId, projectParcelId) =>
    axiosInstance.get(
      `${PARCEl_NUMBER_URL}/${projectId}/parcel/${projectParcelId}/buildingRules`
    ),
  getParcelBuildingCodesByParcelObjectId: (parcelObjectId) =>
    misbarInstance.get(`/parcel/buildingRules`, { params: { parcelObjectId } }),

  sendSellingPrice: (projectId, parcelObjectId, sellingPrice) =>
    axiosInstance.put(
      `${PROJECT_URL}/${projectId}/parcel/${parcelObjectId}/sellingPrice`,
      sellingPrice
    ),
};

export default parcelApi;
